var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewEmailAddress = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    viewBox: "0 0 27 27",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D5B66",
    d: "M16.49 12.864v.014a2.994 2.994 0 0 1-2.99 2.992 2.995 2.995 0 0 1-2.992-2.992 2.991 2.991 0 0 1 5.983-.014"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D5B66",
    d: "M13.5 1.062c-6.516 0-11.816 5.301-11.816 11.816s5.3 11.816 11.816 11.816c6.515 0 11.816-5.3 11.816-11.816 0-6.515-5.3-11.816-11.816-11.816m5.844 16.368c-.948 0-1.759-.666-2.272-1.736A4.54 4.54 0 0 1 13.5 17.43a4.557 4.557 0 0 1-4.552-4.552c0-2.51 2.042-4.55 4.552-4.55a4.544 4.544 0 0 1 4.55 4.496v.054c.005 1.827.769 2.992 1.294 2.992s1.284-1.158 1.292-2.974v-.018c0-3.935-3.201-7.136-7.136-7.136s-7.137 3.201-7.137 7.136a7.1 7.1 0 0 0 1.173 3.923l.005.006q.04.062.068.128l.013.034a.5.5 0 0 1 .03.101.6.6 0 0 1 .018.167v2.029h2.472q.055 0 .11.008l.038.007.038.009a1 1 0 0 1 .137.05 7.1 7.1 0 0 0 3.035.675.78.78 0 0 1 0 1.56 8.6 8.6 0 0 1-3.537-.75H7.138a1.03 1.03 0 0 1-1.028-1.027v-2.334a8.65 8.65 0 0 1-1.307-4.586c0-4.795 3.902-8.696 8.697-8.696a8.69 8.69 0 0 1 8.697 8.682c0 2.603-1.226 4.566-2.853 4.566"
  })));
};
export default SvgNewEmailAddress;